/** Figma 5724-11865 — Remix line icons matching Figma component names. */
import type { IconType } from 'react-icons'
import {
  RiBriefcaseLine,
  RiBuilding2Line,
  RiCakeLine,
  RiDiamondRingLine,
  RiGraduationCapLine,
  RiHome4Line,
  RiParentLine,
  RiRoadMapLine,
  RiTeamLine,
  RiUser3Line,
} from '@/shared/icons/remix'

export const accountDemographicIconColor = '#0f172a'

export const accountDemographicIcons: Record<string, IconType> = {
  gender: RiUser3Line,
  /** Figma: diamond-ring-line */
  maritalStatus: RiDiamondRingLine,
  /** Figma: cake-line */
  dateOfBirth: RiCakeLine,
  householdSize: RiTeamLine,
  city: RiRoadMapLine,
  employment: RiBriefcaseLine,
  numberOfChildren: RiParentLine,
  /** Distinct from employment (briefcase) and children (parent) */
  industry: RiBuilding2Line,
  /** Figma: graduation cap (education level row) */
  education: RiGraduationCapLine,
  housingStatus: RiHome4Line,
}
